var compiledApi = require("./compiledApi");

export const api = compiledApi;

export default {
	api,
};

// http://backend.gogoride.in/
